import { ComponentRegistry } from '@sg-core/resources/assets/js/libs/component-registry';

export class PiaComponentRegistry extends ComponentRegistry {
  protected getModules(): Record<string, () => Promise<unknown>> {
    return import.meta.glob('/modules/SG/maisons/pia/src/View/Components/**/*.ts');
  }
}
